import React, { useState } from 'react';
import { db } from '../../firebase';
import { collection, addDoc } from 'firebase/firestore';
import './SubmitForm.css';

const FormComponent = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    howDidYouHear: '',
    incorporated: '',
    info: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await addDoc(collection(db, 'users'), formData);
      setSubmitted(true);
    } catch (error) {
      console.error('Error adding data:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  if (submitted) {
    return (
      <div className="form-success">
        <div className="form-success-icon">✓</div>
        <h3>Thank you!</h3>
        <p>We've received your submission and will be in touch soon.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="contact-form">
      <div className="form-row">
        <div className="form-field">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="John Doe"
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="company">Company</label>
          <input
            id="company"
            type="text"
            name="company"
            maxLength="24"
            value={formData.company}
            onChange={handleChange}
            placeholder="Acme Inc."
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="john@example.com"
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="phone">Phone</label>
          <input
            id="phone"
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="(555) 123-4567"
          />
        </div>
      </div>

      <div className="form-field">
        <label htmlFor="howDidYouHear">How did you hear about us?</label>
        <input
          id="howDidYouHear"
          type="text"
          name="howDidYouHear"
          maxLength="50"
          value={formData.howDidYouHear}
          onChange={handleChange}
          placeholder="LinkedIn, referral, etc."
        />
      </div>

      <div className="form-field">
        <label htmlFor="info">Tell us about your project</label>
        <textarea
          id="info"
          name="info"
          value={formData.info}
          onChange={handleChange}
          placeholder="Describe your project goals, timeline, and any specific requirements..."
          rows="5"
        />
      </div>

      <button type="submit" className="btn btn-primary form-submit" disabled={submitting}>
        {submitting ? 'Sending...' : 'Send Message'}
      </button>
    </form>
  );
};

export default FormComponent;
